const validateOptions = (options) => {
  ['top', 'basedOn'].forEach((field) => {
    if (!Object.prototype.hasOwnProperty.call(options, field)) {
      throw new TypeError(`Missing required field: ${field}`);
    }
  });
};

const sumStats = (stats) => stats.reduce((sum, stat) => sum + stat.value, 0);

const getTopReviewers = (reviewerStats, top) => reviewerStats
  .map(({ reviewer, stats }) => ({ name: reviewer.name, total: sumStats(stats) }))
  .sort((a, b) => b.total - a.total)
  .slice(0, top)
  .map(({ name }) => name);

export const filterTopReviewers = (timeSeries, options) => {
  if (!timeSeries) return null;

  validateOptions(options);

  const { top, basedOn } = options;
  const { reviewerStats } = timeSeries[basedOn];

  if (top >= reviewerStats.length) return timeSeries;

  const topReviewers = getTopReviewers(reviewerStats, top);

  return Object.fromEntries(
    Object.entries(timeSeries)
      .filter(([key]) => key !== '__typename')
      .map(([stat, data]) => [
        stat,
        {
          aggregatedStats: data.aggregatedStats,
          reviewerStats: data.reviewerStats.filter(
            ({ reviewer }) => topReviewers.includes(reviewer.name),
          ),
        },
      ]),
  );
};
